import React from "react";
import useShopStore from "../store/useShopStore";
import { useEffect } from "react";
import ProductCard from "../components/ProductCard";
import PageHeading from "../utils/PageHeading";
import GridCardContainer from "../utils/GridCardContainer";

export default function Products() {
  const { getProducts, products } = useShopStore((state) => state);
  // const urlparams = document.URL.split("#/").at(1);

  useEffect(() => {
    getProducts();
  }, [getProducts]);
  return (
    <div>
      <PageHeading>Products</PageHeading>
      <GridCardContainer style={{ marginBottom: "10rem" }}>
        {products?.map((product) => {
          return (
            <ProductCard
              image={product.image}
              title={product.name}
              category={product.category}
              price={product.price}
              key={product._id}
              id={product._id}
            />
          );
        })}
      </GridCardContainer>
    </div>
  );
}
